// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { formatText} = require('core/i18n').i18n;

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { CONFIRMATION_PAGE } = require("constants/biocatch");

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

const SuccessStep = () => {
    changeBiocatchContext(CONFIRMATION_PAGE);
    const titleSuccess = formatText('eCommerceKeyModify-titleSuccess');
    const successSubMessage = formatText('eCommerceKeyModify-successSubMessage');
    const messageModifySuccess = formatText('eCommerceKeyModify-messageModifySuccess');
    const mainButtonLabel = formatText('eCommerceKeyModify-backToEcommerceKey');
    const mainButton = {
        label: mainButtonLabel
    };


    return (
        <div className="col-xs-offset-1 col-xs-10">
            <WizardSuccess
                mainButton={mainButton}
                processType={null}
                successMessage={titleSuccess}
                successSubMessage={successSubMessage}
            >
                {messageModifySuccess}
            </WizardSuccess>
        </div>
    );
};

SuccessStep.propTypes = {
    processType: PropTypes.string,
}

SuccessStep.defaultProps = {
    processType: null,
};

module.exports = SuccessStep;
